import { sortByKey } from '@semios/app-platform-common'
import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import type { TOptions } from 'components/MultiSelect/MultiSelect.types'
import { translate } from 'i18n/i18n'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect } from 'react'
import { colors } from 'settings/colors'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { ErrorTextWrapper } from '../../components/ErrorTextWrapper'

const propertyOptionGenerator = (properties: TProperty[]) => {
  const propertiesData = properties
    .map((property: TProperty) => ({
      label: property.propertyName,
      value: property.propertyId.toString(),
      id: `${property.propertyId}-PROPERTY`,
    }))
    .sort(sortByKey('label'))

  return [...propertiesData]
}

export const ReportProperties = ({
  setSelectedReportProperties,
  setPropertiesIsValid,
  selectedReportProperties,
  properties,
  triedToSubmit,
}: {
  setSelectedReportProperties: Dispatch<SetStateAction<TOptions[]>>
  setPropertiesIsValid: Dispatch<SetStateAction<boolean>>
  selectedReportProperties: TOptions[]
  properties: TProperty[]
  triedToSubmit: boolean
}) => {
  let helpText = ''
  let validateStatusError = false

  if (selectedReportProperties.length === 0 && triedToSubmit) {
    helpText = translate.phrases.banyanApp('At least one property must be selected')

    validateStatusError = true
  } else if (selectedReportProperties.length === 0) {
    validateStatusError = true
  }

  useEffect(() => {
    setPropertiesIsValid(!validateStatusError)
  }, [selectedReportProperties])

  const sortedSelectedProperties = selectedReportProperties.sort((a, b) => {
    const valueA = typeof a.label === 'string' ? a.label : String(a.label)
    const valueB = typeof b.label === 'string' ? b.label : String(b.label)

    return valueA.localeCompare(valueB)
  })

  const propertyOptions = propertyOptionGenerator(properties)

  return (
    <div css={{ paddingBottom: '25px', borderBottom: `1px solid ${colors.grey200}` }}>
      <h4>{translate.phrases.banyanApp('Properties')}</h4>
      <p css={{ marginBottom: '0px', marginTop: '10px', fontSize: '12px' }}>
        {translate.phrases.banyanApp('Select specific properties')}
      </p>
      <div css={{ marginTop: '15px' }}>
        <MultiSelect
          data={propertyOptions}
          selectedData={sortedSelectedProperties}
          placeholder={translate.phrases.banyanApp('Select Properties')}
          onChange={(selectedValues: TOptions[]) => {
            setSelectedReportProperties(selectedValues.map((option) => option))
          }}
        />
      </div>
      {validateStatusError && <ErrorTextWrapper>{helpText}</ErrorTextWrapper>}
    </div>
  )
}
